// safetyFormLists/slice.js

import { nearMissListInitialState } from "./nearMissList/safetyFormListsNearMissListsState";
import { makeNearMissListActions } from "./nearMissList/safetyFormListsNearMissListsActions";
import { safetyAuditListInitialState } from "./safetyAuditList/safetyFormListsSafetyAuditListState";
import { makeSafetyAuditListActions } from "./safetyAuditList/safetyFormListsSafetyAuditListActions";
import { safetyFormReportsInitialState } from "./safetyFormReports/safetyFormListsSafetyFormReportsState";
import { makeSafetyFormReportsActions } from "./safetyFormReports/safetyFormListsSafetyFormReportsActions";

export const createSafetyFormListsSlice = (set, get) => ({
  safetyFormLists: {
    nearMissList: nearMissListInitialState,
    safetyAuditList: safetyAuditListInitialState,
    safetyFormReports: safetyFormReportsInitialState,
  },
  safetyFormListsActions: Object.freeze({
    // Fetch all first pages for the safety forms
    fetchInitialSafetyFormLists: async (employeeId, forceRefresh = false) => {
      if (forceRefresh) {
        set((s) => ({
          safetyFormLists: {
            ...s.safetyFormLists,
            nearMissList: {
              ...s.safetyFormLists.nearMissList,
              currentPage: 1,
            },
          },
        }));
      }
      set((s) => ({
        safetyFormLists: { ...s.safetyFormLists, isLoading: true, error: null },
      }));
      try {
        const { fetchNearMissListDraftsPage } = get().safetyFormListsActions;
        const { fetchSafetyAuditListDraftsPage } = get().safetyFormListsActions;
        await Promise.all([
          fetchNearMissListDraftsPage(employeeId),
          fetchSafetyAuditListDraftsPage(employeeId),
        ]);
        set((s) => ({
          safetyFormLists: { ...s.safetyFormLists, isLoading: false },
        }));
      } catch (err) {
        console.error("Failed to fetch initial safety form lists:", err);
        set((s) => ({
          safetyFormLists: {
            ...s.safetyFormLists,
            isLoading: false,
            error: err.message,
          },
        }));
      }
    },
    // Tab specific actions
    ...makeNearMissListActions(set, get),
    ...makeSafetyAuditListActions(set, get),
    ...makeSafetyFormReportsActions(set, get),
  }),
});
